<template>
  <div class="valueInput MGbottom5px">
    <div v-if="months" class="bold">{{ title.split(" ")[0] }} <span
          class="medium">{{ title.split(" ")[1] }}</span></div>
    <div v-else class="month">{{ title }}</div>

    <div v-if="!fullfilling" class="salary">
      <input :readonly="readonly" ref="main-input" :step="interval ? interval : 1000" @focusout="$emit('focusout', $event)"
              placeholder="-" :max="max ? max : Infinity" type="number" pattern="[0-9]+([\.,][0-9]+)?" inputmode="decimal" v-model="value">

      <div class="" style="width: 50px; text-align: left">
        {{ after ? after : 'EUR' }}</div>
    </div>
    <div v-else class="text-right">
      <div class="spinner-border text-primary" style="width: 1rem; height: 1rem" role="status"></div>
    </div>

    <div v-if="vanishable" class="icon" @click="vanish">
      <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.0814 10L7.44186 7.98535L5.86047 10H5L7.04651 7.5L5.02326 5H5.94186L7.55814 6.98718L9.12791 5H9.97674L7.95349 7.47253L10 10H9.0814Z"
            fill="white"/>
      </svg>
    </div>
 </div>
</template>

<script>
export default {
  name: "ValueInput",
  props: {
    title: String,
    initValue: Number,
    after: String,
    interval: Number,
    max: Number,
    min: Number,
    months: Boolean,
    dataRef: String,
    vanishable: Boolean,
    readonly: Boolean,
    fullfilling: Boolean
  },
  beforeDestroy() {
    this.$refs["main-input"].value = null;
  },
  data: () => ({
    value: null,
    minData: -Infinity
  }),
  created() {
    if (this.initValue != null)
      this.value = this.initValue;
    if (this.min !== undefined)
      this.minData = this.min;
  },
  methods: {
    vanish() {
      this.$emit("vanish");
    }
  },
  watch: {
    value(to) {
      to = Number(to);

      if (to > this.max) {
        this.value = this.max;
      } else if (to < this.minData) {
        this.value = this.minData;
      }

      this.$emit("change", {dataRef: this.dataRef, value: to});
    },
    initValue(to) {
      this.value = to;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>